module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container page-content"
  }, [_c('div', {
    staticClass: "row pb-5"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-12"
  }, [_c('form', {
    attrs: {
      "name": "Parceiro",
      "id": "formParceiro"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.sendMail($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "Parceiro_razao_social"
    }
  }, [_vm._v("Razão Social:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formParceiro.razao_social),
      expression: "formParceiro.razao_social"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "Parceiro_razao_social",
      "name": "razao_social",
      "required": "required"
    },
    domProps: {
      "value": (_vm.formParceiro.razao_social)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formParceiro.razao_social = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "Parceiro_nome_fantasia"
    }
  }, [_vm._v("Nome Fantasia:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formParceiro.nome_fantasia),
      expression: "formParceiro.nome_fantasia"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "Parceiro_nome_fantasia",
      "name": "nome_fantasia",
      "required": "required"
    },
    domProps: {
      "value": (_vm.formParceiro.nome_fantasia)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formParceiro.nome_fantasia = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "Parceiro_cnpj"
    }
  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formParceiro.cnpj),
      expression: "formParceiro.cnpj"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "Parceiro_cnpj",
      "name": "cnpj",
      "required": "required"
    },
    domProps: {
      "value": (_vm.formParceiro.cnpj)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formParceiro.cnpj = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "Parceiro_ie"
    }
  }, [_vm._v("IE:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formParceiro.ie),
      expression: "formParceiro.ie"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "Parceiro_ie",
      "name": "ie",
      "required": "required"
    },
    domProps: {
      "value": (_vm.formParceiro.ie)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formParceiro.ie = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "Parceiro_nome_contato"
    }
  }, [_vm._v("Nome para Contato:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formParceiro.nome_contato),
      expression: "formParceiro.nome_contato"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "Parceiro_nome_contato",
      "name": "nome_contato",
      "required": "required"
    },
    domProps: {
      "value": (_vm.formParceiro.nome_contato)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formParceiro.nome_contato = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "Parceiro_email"
    }
  }, [_vm._v("Email:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formParceiro.email),
      expression: "formParceiro.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "Parceiro_email",
      "name": "email",
      "required": "required"
    },
    domProps: {
      "value": (_vm.formParceiro.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formParceiro.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "Parceiro_tel_fixo"
    }
  }, [_vm._v("Telefone Fixo:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formParceiro.tel_fixo),
      expression: "formParceiro.tel_fixo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "Parceiro_tel_fixo",
      "name": "tel_fixo",
      "required": "required"
    },
    domProps: {
      "value": (_vm.formParceiro.tel_fixo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formParceiro.tel_fixo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "Parceiro_celular"
    }
  }, [_vm._v("Celular:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formParceiro.celular),
      expression: "formParceiro.celular"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "Parceiro_celular",
      "name": "celular",
      "required": "required"
    },
    domProps: {
      "value": (_vm.formParceiro.celular)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formParceiro.celular = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "Parceiro_motivo_parceria"
    }
  }, [_vm._v("Porque deseja ser um parceiro da Simonetti?")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formParceiro.motivo_parceria),
      expression: "formParceiro.motivo_parceria"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "Parceiro_motivo_parceria",
      "name": "motivo_parceria",
      "required": "required",
      "rows": "5"
    },
    domProps: {
      "value": (_vm.formParceiro.motivo_parceria)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formParceiro.motivo_parceria = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("Estado:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formParceiro.estado),
      expression: "formParceiro.estado"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "estado",
      "required": "required",
      "id": "estados"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.formParceiro.estado = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Escolha um Estado")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BH"
    }
  }, [_vm._v("Bahia")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ES"
    }
  }, [_vm._v("Espirito Santo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MG"
    }
  }, [_vm._v("Minas Gerais")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "Parceiro_cidade"
    }
  }, [_vm._v("Cidade:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formParceiro.cidade),
      expression: "formParceiro.cidade"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "Parceiro_cidade",
      "name": "cidade",
      "required": "required"
    },
    domProps: {
      "value": (_vm.formParceiro.cidade)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formParceiro.cidade = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12 text-center"
  }, [(_vm.enviandoEmail) ? _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("\n                            Aguarde...\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.emailEnviado) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("\n                            Aguarde, nossa equipe entrará em contato com você! Faremos um bom negócio!\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.emailNaoEnviado) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v("\n                            Houve um problema ao enviar seu email, tente novamente.\n                        ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-danger",
    attrs: {
      "type": "submit",
      "id": "Parceiro_enviar"
    }
  }, [_vm._v("\n                            Quero ser um parceiro\n                        ")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid page-title"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("\n                Seja um Parceiro\n            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-6 col-md-12 text-justify"
  }, [_c('h3', {
    staticStyle: {
      "font-weight": "300",
      "color": "#c70000"
    }
  }, [_vm._v("Nada na sua empresa será como antes.")]), _vm._v(" "), _c('b', [_vm._v("\n                    Assista ao vídeo e conheça o nosso modelo de negócios, que é focado na simplicidade e no acesso\n                    facilitado a você, Empreendedor.\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "embed-responsive embed-responsive-16by9 mt-2 mb-2"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "src": "https://www.youtube.com/embed/mbsmQFoV11A",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })]), _vm._v(" "), _c('b', [_vm._v("\n                    Temos a melhor oportunidade de crescimento para o seu negócio,"), _c('br'), _vm._v("\n                    entre em contato que juntos faremos as suas vendas decolarem!\n                ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1be9f643","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/src/pages/SejaParceiro.vue
// module id = 869
// module chunks = 0